//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';

import constant from '~/const';
import tableConfig from './tableConfig';
import actionsConfig from './actionsConfig';

export default {

  data() {
    return {
      tableConfig,
      actionsConfig,
      selection: [],
      constant,
      editingModal: {
        show: false,
        data: {},
        isCreating: false,
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('tradersCurrencies', ['page', 'pages', 'data', 'sort']),
    ...mapState('tradersPaymentMethods', {
      paymentMethods: 'data',
    }),

    attach() {
      return this.editingModal?.data?.icon;
    },

    isFileLarge() {
      if (!this.attach) return false;
      return this.attach.size > 1000000;
    },

    isApplyPossible() {
      return this.isFileLarge;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('tradersCurrencies', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      editAction: 'edit',
      createAction: 'create',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      // SINGLE TABLE COMPONENT
      // const query = { page: value };
      // this.$router.replace({ query });

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    openModalEdit(row) {
      const { paymentMethodIds, ...data } = row;
      this.editingModal.data = { ...data, paymentMethods: paymentMethodIds };
      this.editingModal.isCreating = false;
      this.editingModal.show = true;
    },

    openModalCreate() {
      this.editingModal.data.name = '';
      this.editingModal.data.title = '';
      this.editingModal.data.type = constant.traders.CURRENCY_TYPE.CRYPTO;
      this.editingModal.data.decimal = 8;
      this.editingModal.data.isEnabled = true;

      this.editingModal.isCreating = true;
      this.editingModal.show = true;
    },

    async apply() {
      this.setGeneralProgress(true);
      const data = {
        ...this.editingModal.data,
      };

      if (this.editingModal.data.icon) {
        const base64String = await this.$utils.convertToBase64(this.editingModal.data.icon);
        data.icon = base64String;
      }
      try {
        if (this.editingModal.isCreating) {
          await this.createAction(data);
          this.setSuccessNotification('Currency created');
        } else {
          await this.editAction(data);
          this.setSuccessNotification('Currency edited');
        }
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      await this.loadDataAction();
      this.editingModal.data = {};
      this.editingModal.data.type = constant.traders.CURRENCY_TYPE.CRYPTO;
      this.editingModal.data.decimal = 8;
      this.editingModal.data.isEnabled = true;
      this.setGeneralProgress(false);
    },

    getPaymentMethodById(id) {
      return this.paymentMethods.find((e) => e.id === id) ?? {};
    },
  },
};
